/**
 * Transforma um número em um mês abreviado, por exemplo:
 * ```ts
 * mesParaAbreviacao(1) === 'Jan';
 * mesParaAbreviacao(3) === 'Mar';
 * mesParaAbreviacao(12) === 'Dez';
 * ```
 *
 * @param mes Número entre 1 e 12
 * @returns O nome do mês abreviado no formato `'Aaa'`,
 *   retorna `''`, caso o número fornecido seja inválido
 */
export const mesParaAbreviacao = (mes: number) => {
  const nomesDosMeses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

  // Subtrai 1 para ajustar o índice (1 a 12 para 0 a 11)
  return mes === 0 ? '' : (nomesDosMeses[mes - 1] ?? '');
};
